module.exports = __webpack_public_path__ + "static/img/relationNew3.2b67019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/relation/relationNew3.jpg
// module id = +tAA
// module chunks = 0